import React from 'react'
import { css } from '@emotion/core'
import { FrontTabletFontSize } from '@/constants/front-tablet-typography'
import {
  createSelfCheckinBaseStyle,
  createSelfCheckinResponsiveStyle,
  FrontTabletResponsiveToken,
} from '@/utils/front-tablet-responsive-style'

type ComponentProps = {
  error?: boolean
  maxWidth?: number
} & React.ComponentPropsWithoutRef<'input'>

const FrontTabletInputField = React.forwardRef<HTMLInputElement, ComponentProps>(({ error, maxWidth, ...props }, ref) => {
  return <input {...props} ref={ref} css={[inputStyle, maxWidth && css({ maxWidth }), error && errorInputStyle]} />
})
FrontTabletInputField.displayName = 'FrontTabletInputField'
export { FrontTabletInputField }

const inputStyle = css(
  {
    height: 59,
    width: '100%',

    border: '1px solid #CCCCCC',
    borderRadius: 30,
    fontSize: FrontTabletFontSize.formInput,
    fontWeight: 500,
    letterSpacing: '1.1px',
    padding: '14px 30px 15px 35px',

    '::placeholder': {
      color: '#CCCCCC',
    },
  },
  createSelfCheckinBaseStyle({ fontSize: FrontTabletResponsiveToken.formInputFontSize.landscape11 }),
  createSelfCheckinResponsiveStyle({
    landscape13: {
      fontSize: FrontTabletResponsiveToken.formInputFontSize.landscape13,
      height: 64,
      letterSpacing: '1.3px',
    },
  }),
)

const errorInputStyle = css({
  borderColor: '#ff2700 !important',
})
